export function Refund() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Politica de reembolso 48h</h1>

      <div className="mt-8 space-y-6 text-text-secondary">
        <div className="card border-accent-primary bg-accent-primary/5">
          <p className="text-lg font-semibold text-text-primary">
            Tienes 48 horas desde la compra o renovacion para solicitar reembolso completo.
          </p>
          <p className="mt-2 text-sm">
            Sin preguntas. Sin penalizaciones. Self-service.
          </p>
        </div>

        <h2 className="text-2xl font-bold">Como solicitar tu reembolso</h2>
        <ol className="list-decimal pl-6">
          <li>Inicia sesion en tu cuenta.</li>
          <li>Ve a <code className="font-mono text-sm">/app/account</code>.</li>
          <li>En la seccion "Suscripcion", clic en "Solicitar reembolso".</li>
          <li>Confirma. El reembolso se procesa via Paddle automaticamente.</li>
          <li>Recibiras email confirmacion en menos de 24 horas habiles.</li>
        </ol>

        <h2 className="mt-8 text-2xl font-bold">Plazos</h2>
        <ul>
          <li>Solicitud: dentro de 48 horas desde compra/renovacion.</li>
          <li>Procesamiento Paddle: 1-3 dias habiles tras solicitud.</li>
          <li>Reflejo en tu metodo de pago: 5-10 dias habiles dependiendo del banco.</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">Casos fuera de la ventana de 48h</h2>
        <p>
          Solicitudes fuera de plazo se evaluan caso por caso a discrecion del equipo. Escribenos
          a <a href="mailto:paul.marquina@outlook.com" className="text-accent-primary hover:underline">
            paul.marquina@outlook.com
          </a>{' '}
          con detalle del problema.
        </p>

        <h2 className="mt-8 text-2xl font-bold">Que no es reembolsable</h2>
        <ul>
          <li>Suscripciones canceladas que ya pasaron 48h.</li>
          <li>Bundles parcialmente consumidos donde aplique restriccion explicita.</li>
        </ul>

        <hr className="my-8 border-border-subtle" />

        <p className="text-xs text-text-tertiary">
          La politica forma parte de los <a href="/terminos" className="text-accent-primary hover:underline">terminos
          y condiciones</a>. Implementacion del flujo: tarea RC-PAY-040 (Sprint 11).
        </p>
      </div>
    </div>
  );
}
